import { useEffect } from 'react';

import { getAppGlobals } from '~/components/AppGlobals/utils';
import { isStytchDfpEnabled } from '~/utils/stytch';

const DEFAULT_TELEMETRY_SRC = 'https://elements.stytch.com/telemetry.js';

const StytchEmbed = () => {
  const appGlobals = getAppGlobals();

  useEffect(() => {
    if (!isStytchDfpEnabled()) return;

    try {
      const stytchScript = document.createElement('script');
      stytchScript.src = appGlobals.VITE_STYTCH_TELEMETRY_URL || DEFAULT_TELEMETRY_SRC;
      stytchScript.async = true;
      document.head.appendChild(stytchScript);

      return () => {
        if (document.head.contains(stytchScript)) {
          document.head.removeChild(stytchScript);
        }
      };
    } catch {
      // ignore
    }
  }, [appGlobals]);

  return null;
};

export default StytchEmbed;
